/* 2009-2018 Copyright Ridecell Inc. All rights reserved. */
module.exports = typeof document !== 'undefined' ? document : {} // eslint-disable-line no-undef
